// extracted by mini-css-extract-plugin
export default {"themeGrandFrais":"BlockReceipts_themeGrandFrais__PjUZU","themeFresh":"BlockReceipts_themeFresh__73+wH","receipts":"BlockReceipts_receipts__tuvyC","link":"BlockReceipts_link__I+NP7"};